var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileicons(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1056 1.34729H4.04264C3.68531 1.34729 3.34261 1.48924 3.08994 1.74191C2.83726 1.99459 2.69531 2.33729 2.69531 2.69462V13.4733C2.69531 13.8306 2.83726 14.1733 3.08994 14.426C3.34261 14.6787 3.68531 14.8206 4.04264 14.8206H12.1266C12.484 14.8206 12.8267 14.6787 13.0793 14.426C13.332 14.1733 13.474 13.8306 13.474 13.4733V4.71562L10.1056 1.34729Z",
    stroke: "#8B5CF6",
    strokeWidth: 1.0105,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.42969 1.34729V4.04195C9.42969 4.39929 9.57164 4.74199 9.82431 4.99466C10.077 5.24733 10.4197 5.38928 10.777 5.38928H13.4717",
    stroke: "#8B5CF6",
    strokeWidth: 1.0105,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.736 6.06299H5.38867",
    stroke: "#8B5CF6",
    strokeWidth: 1.0105,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.778 8.75769H5.38867",
    stroke: "#8B5CF6",
    strokeWidth: 1.0105,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.778 11.4523H5.38867",
    stroke: "#8B5CF6",
    strokeWidth: 1.0105,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileicons);
export default __webpack_public_path__ + "static/media/fileicons.24b7b30cdfce473e91af2645335cb993.svg";
export { ForwardRef as ReactComponent };